var _circle, _circle2, _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _circle3, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#A7E340"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2947_2654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#A7E340"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2947_2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 46L6 31L28 9L32.5 10L45 18L27.5 46Z",
    fill: "#95CC37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 10.8954 6.89543 10 8 10H32C33.1046 10 34 10.8954 34 12V16H6V12Z",
    fill: "#FF461E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H32C33.1046 10 34 10.8954 34 12V16H20V10Z",
    fill: "#E42C06"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 28,
    height: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 14,
    height: 15,
    fill: "#F0F0F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 2,
    height: 3,
    fill: "#1B3B6B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 9,
    width: 2,
    height: 3,
    fill: "#1B3B6B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 23,
    r: 3,
    fill: "#FF9500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23C23 24.6569 21.6569 26 20 26C20 26 20 24.6569 20 23C20 21.3431 20 20 20 20C21.6569 20 23 21.3431 23 23Z",
    fill: "#FE8205"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 18,
    rx: 0.5,
    ry: 1,
    fill: "#FFDB2F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 28,
    rx: 0.5,
    ry: 1,
    fill: "#FFDB2F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.614,
    cy: 24.9923,
    rx: 0.5,
    ry: 1,
    transform: "rotate(-66.9213 24.614 24.9923)",
    fill: "#FFDB2F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0211,
    cy: 27.0902,
    rx: 0.5,
    ry: 1,
    transform: "rotate(-39.3951 23.0211 27.0902)",
    fill: "#FFDB2F"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 23,
    rx: 0.5,
    ry: 1,
    transform: "rotate(-90 25 23)",
    fill: "#FFDB2F"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9498,
    cy: 19.1138,
    rx: 0.5,
    ry: 1,
    transform: "rotate(-148.394 22.9498 19.1138)",
    fill: "#FFDB2F"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4338,
    cy: 20.8427,
    rx: 0.5,
    ry: 1,
    transform: "rotate(-112.36 24.4338 20.8427)",
    fill: "#FFDB2F"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.386,
    cy: 21.1879,
    rx: 0.5,
    ry: 1,
    transform: "rotate(113.079 15.386 21.1879)",
    fill: "#FFDB2F"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9789,
    cy: 19.09,
    rx: 0.5,
    ry: 1,
    transform: "rotate(140.605 16.9789 19.09)",
    fill: "#FFDB2F"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 23.1802,
    rx: 0.5,
    ry: 1,
    transform: "rotate(90 15 23.1802)",
    fill: "#FFDB2F"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.0502,
    cy: 27.0663,
    rx: 0.5,
    ry: 1,
    transform: "rotate(31.6065 17.0502 27.0663)",
    fill: "#FFDB2F"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5662,
    cy: 25.3375,
    rx: 0.5,
    ry: 1,
    transform: "rotate(67.6398 15.5662 25.3375)",
    fill: "#FFDB2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidays);
export default __webpack_public_path__ + "static/media/Holidays.6777e5312ec70f26299d80d42994c542.svg";
export { ForwardRef as ReactComponent };